export default function authHeader() {
    const user = localStorage.getItem('lasuris-jwt');

    if (user != null) {
        return user;
    } else {
        return {};
    }
}